<template>
    <div class="h-100 d-flex flex-column" style="min-height: 390px">
        <div v-if="external">
            <b-alert show class="py-1 mt-0" variant="warning" id="alert">
                <div class="d-flex flex-row">
                    <div class="flex-fill my-auto">
                        External Images Blocked
                    </div>
                    <div>
                        <b-btn variant="link" size="sm" small @click="loadImages(true)">Enable</b-btn>
                    </div>
                </div>
            </b-alert>
        </div>

        <!-- The frame is taken out of the flow: when it is zoomed out to fit a wide email it is
             laid out at width / zoom and height / zoom and scaled down, and a transform does not
             shrink its layout box. In the flow, that box set the wrap's height, the next resize()
             read that height back and divided by the zoom again, and the modal grew with every
             image that loaded. Absolute, it takes the wrap's size and never gives any back. -->
        <div id="message-wrap" class="flex-fill position-relative overflow-hidden">
            <iframe class="overflow-auto position-absolute" style="border: none; outline: none; top: 0; left: 0;" id="message-iframe"
                    @load="loaded"
                    :srcdoc="message.content"/>
        </div>
        <div>
            <!--<b-input type="range" size="sm" class="mb-0 pb-0" v-model="zoom" min="25" max="200"/>-->
        </div>
    </div>
</template>

<script>
import {fitZoom, onImagesLoaded, prepareEmail} from "@/lib/email-fit";

export default {
     name: "message-content",

    props: {
        message: Object,
    },

    data() {
        return {
            external: false,
            height: 0,
            width: 0,
            zoom: 100
        }
    },

    mounted() {
        this.external = !!Object.values(this.message.inline_images).find(f => f.external)
    },

    watch: {
        zoom() {
            this.resize()
        }
    },

    methods: {
        resize() {
            this.height = document.getElementById('message-wrap').offsetHeight
            this.width = document.getElementById('message-wrap').offsetWidth
            const iframe = document.getElementById('message-iframe')
            iframe.style.height = (this.height * (1 / (this.zoom / 100))) + 'px'
            iframe.style.width = (this.width * (1 / (this.zoom / 100))) + 'px'
            iframe.style.webkitTransform = "scale(" + (this.zoom / 100) + ")"
            iframe.style.webkitTransformOrigin = "0 0"
        },

        loaded() {
            const body = document.getElementById("message-iframe").contentDocument.body
            body.style.fontFamily = 'sans-serif'
            body.style.fontSize = '0.95rem'
            body.style.lineHeight = 1.4
            body.style.paddingLeft = '4px'
            body.style.paddingRight = '4px'

            if (this.message.is_plain)
                body.style.whiteSpace = 'pre-line'

            const doc = document.getElementById("message-iframe").contentDocument
            prepareEmail(doc)
            this.loadImages()
            this.autozoom()
            this.resize()
            // images change the width as they arrive: fit again
            onImagesLoaded(doc, () => { this.autozoom(); this.resize() })
        },

        autozoom() {
            const iframe = document.getElementById("message-iframe")
            const width = document.getElementById('message-wrap').clientWidth
            const fit = fitZoom(iframe, width, 60)
            if (fit !== null) {
                this.zoom = fit
                return true
            } else if (this.message.source == 'e' || this.message.is_plain) {
                this.zoom = 100
                return true
            }
            this.zoom = 100
            return false
        },

        loadImages(external) {
            if (!this.message.inline_images)
                return

            const images = document.getElementById('message-iframe').contentDocument.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                const img = images[i]
                const data = this.message.inline_images[img.id]
                if (data) {
                    if (!external && data.external)
                        continue;

                    img.src = data.url
                }
            }
            if (external)
                this.external = false

            this.$nextTick(() => {
                this.resize()
            })
        }

    }
}
</script>

<style scoped>

</style>